import { Group } from '@/components/_common';
import AccountReceivableListModal from '@/components/_common/AccountReceivableListModal';
import { useAccountReceivableList } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { AccountReceivableSituation } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useDisclosure } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { DateTimeFormat } from '@/utils/moment';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Alert, Button, Col, Typography } from 'antd';
import moment from 'moment';
import React from 'react';
import { AlertTriangle } from 'react-feather';

interface Props {
  customerId?: number;
}

const CustomerDefaulterAlert: React.FC<Props> = ({ customerId }) => {
  const [installmentsCustomerModalOpen, installmentsCustomerModalActions] =
    useDisclosure();

  const { data: customerInstallments } = useAccountReceivableList(
    {
      order: 'DESC',
      rows: 1,
      customerId: customerId,
      situation: AccountReceivableSituation.open,
      finalDueDate: moment()
        .subtract(1, 'day')
        .set({ minute: 0, second: 0 })
        .format(DateTimeFormat),
    },
    !!customerId,
  );

  const installmentsCustomer = flatInfiniteData(customerInstallments).filter(
    (item) => item.customerId === customerId,
  );

  return (
    <>
      {!!installmentsCustomer.length && (
        <Alert
          type="error"
          description={
            <Col span={24}>
              <Typography.Title level={5}>
                <Group align="start" gap={10}>
                  <AlertTriangle size={24} color="red" />
                  <span>Cliente com inadimplência no contas a receber</span>
                </Group>
              </Typography.Title>

              <Button
                onClick={installmentsCustomerModalActions.open}
                style={{ width: '100%' }}
                type="ghost"
                disabled={
                  !hasPermissions([
                    Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_VIEW,
                    Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_LAUCH,
                  ])
                }
              >
                Listar parcelas
              </Button>
            </Col>
          }
        />
      )}

      <AccountReceivableListModal
        open={installmentsCustomerModalOpen}
        onCancel={installmentsCustomerModalActions.close}
        queryFilter={{
          customerId: customerId,
          order: 'DESC',
          situation: AccountReceivableSituation.open,
          finalDueDate: moment()
            .subtract(1, 'day')
            .set({ minute: 0, second: 0 })
            .format(DateTimeFormat),
        }}
      />
    </>
  );
};

export default CustomerDefaulterAlert;
